import PeLink from '@pe-libs/react-components/build/components/PeLink';
import useImage from '@pe-libs/react-components/build/lib/hooks/useImage';
import useIntlMessage from '@pe-libs/react-components/build/lib/intl/hooks/useIntlMessage';
import React from 'react';
import { useSelector } from 'react-redux';
import imageDesktop from '#assets/images/expertDirectory/resultsDesktop.jpg';
import imageMobile from '#assets/images/expertDirectory/resultsMobile.jpg';
import imageTablet from '#assets/images/expertDirectory/resultsTablet.jpg';
import Footer from '#components/Footer';
import { getSearchUrl } from '#helpers/searchUrl';
import { getUserLocale } from '#modules/app/selectors';
import BottomSearchSection from '../BottomSearchSection';
import IndustryCatalogue from '../IndustryDirectory/IndustryCatalogue';
import Article from '../Landing/Article';
import SearchSection from '../SearchSection';
import messages from './messages';
import useStyles from './styles';

const NoResultsPage = () => {
  const styles = useStyles();
  const formatMessage = useIntlMessage();
  const title = formatMessage(messages.noResultsPageTitle);
  const description = formatMessage(messages.noResultsPageDescription);
  const locale = useSelector(getUserLocale)?.toLowerCase() ?? 'de-de';
  const backgroundImg = useImage(imageMobile, imageTablet, imageDesktop);

  const link = (
    <PeLink href={`/${locale}/${getSearchUrl(locale)}/`} className={styles.link}>
      {formatMessage(messages.backToPreviousPage)}
    </PeLink>
  );

  return (
    <div className={styles.container}>
      <SearchSection
        bgImage={backgroundImg}
        hasSearchBar={true}
        title={title}
        description={<div>{description}</div>}
        link={link}
      />
      <div className={styles.sectionIndustryCatalogue}>
        <IndustryCatalogue />
      </div>
      <div className={styles.sectionArticle}>
        <Article />
      </div>
      <BottomSearchSection />
      <Footer />
    </div>
  );
};

export default NoResultsPage;
